import React from 'react';
import styled from 'styled-components';

const NewTabLink = ({ openNewTab = true, ...other }) => {
  const newTabProps = openNewTab && {
    rel: 'noopener noreferrer',
    target: '_blank',
  };

  const anchorElementProps = {
    ...other,
    ...newTabProps,
  };

  return <AnchorElement {...anchorElementProps} />;
};

const AnchorElement = styled.a`
  color: inherit;
  box-shadow: none;
  text-decoration: ${props => (props.underline ? 'underline' : 'none')};
  cursor: pointer;
  &:visited,
  &:hover,
  &:active,
  &:focus {
    text-decoration: none;
    text-decoration: ${props => (props.underline ? 'underline' : 'none')};
  }
`;

export default NewTabLink;
